import { useEffect, useState } from "react";
import { Screen } from "../components/Screen";
import { api } from "../api/client";
import type { UsedCar } from "@karat/shared";

/** п.5 ТЗ. Реального джерела ще немає — див. коментар в Inventory.tsx. */
export function UsedCars() {
  const [items, setItems] = useState<UsedCar[] | null>(null);

  useEffect(() => {
    api.get<UsedCar[]>("/api/used-cars").then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <Screen title="Авто з пробігом" subtitle="Актуальна пропозиція автомобілів з пробігом" showBack>
      {items === null && <div className="loading-row">Завантаження…</div>}
      {items && items.length === 0 && (
        <div className="empty-state">
          <div className="empty-state-icon">🔁</div>
          Пропозицію авто з пробігом оновлюємо.
          <br />
          Зверніться до консультанта відділу автомобілів з пробігом — він підбере варіант під ваш запит.
        </div>
      )}
    </Screen>
  );
}
